import { render, staticRenderFns } from "./stage-display.vue?vue&type=template&id=61176726&scoped=true"
import script from "./stage-display.vue?vue&type=script&lang=ts&setup=true"
export * from "./stage-display.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./stage-display.vue?vue&type=style&index=0&id=61176726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61176726",
  null
  
)

export default component.exports